<template>
  <section>
    <div class="img-wrap select-none text-center" style="width: 184px; height: auto;">
      <img :src="require('@/assets/img/nodata.png')" alt="nodata" />
      <p class="mt-20px">{{ text }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    text: {
      type: String,
      default: '暂无数据'
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
section {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  text-align: center;
  .img-wrap {
    margin: 0 auto;
  }
  p {
    color: var(--color-grey8);
  }
}
</style>
